import useProvider from '@src/hooks/useProvider';
import { MessagingProvider } from '@src/model/frontendmodel';
import { injectIntl } from 'react-intl';
import AttachFilesSummaryAll from './AttachFilesSumaryAll';
import AttachFilesSummaryMeta from './AttachFilesSumaryMeta';

const AttachFilesSummary = injectIntl(() => {
  const provider = useProvider();

  if (provider === MessagingProvider.WHATSAPPB2CHAT)
    return <AttachFilesSummaryMeta />;

  return <AttachFilesSummaryAll />;
});

export default AttachFilesSummary;
